function pluralize(count, string, pluralSuffix = 's') {

    return count === 1 ? string : string + pluralSuffix;

}

export default pluralize;
